<template>
    <div class="row justify-content-center align-content-center" id="site-footer">
        <div class="col-12 text-center text-md-right" :class="siteCols">
            <router-link :to="{name: 'home'}">
                <i class="icon icon-bazaar-logo"></i>
                <span id="site-name">{{ $t('appName') }}</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'SiteFooter',
    computed: {
        ...mapState({
            siteCols: state => state.settings.siteCols
        }),
    }
}
</script>

<style scoped>
#site-footer {
    height: 80px;
    line-height: 80px;
    background: #FFF;
    border-top: solid 1px rgba(151, 151, 151, 0.45);
}

.icon-bazaar-logo {
    width: 51px;
    height: 33px;
}

#site-name {
    color: #212121;
}

#site-name:before {
    vertical-align: middle;
    display: inline-block;
    content: '';
    width: 10px;
    height: 33px;
    border-right: solid 1px rgba(151, 151, 151, 0.45);
    transform: rotate(20deg) translateX(-50%);
    margin: 0 8px;

}
</style>
